import React, {Component} from 'react';

import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const classes = {
    paper: {
      width: '90%',
      margin:'7%',       
      color: '#6a737b',     
    },
    root:{
      color: '#333333' ,  
      paddingTop: '3%',
         margin:20},
    p :{
      color: '#333333' ,
      paddingTop: '3%',
      margin:'2%',
      marginBottom:70} 
  };
  
  const GenListItem=(item) =>{ 
    return(
    <ExpansionPanel align="left" key={item.title} className={classes.root}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        style={{ backgroundColor : '#C1E5DD'}}>
           <div style={{flexBasis: '20%'}}>
           <Typography> 
           
           <span style={{ fontSize : '16px', color: '#333333'   }} > {item.date} <br/> </span>
           
          <span style={{  fontSize : '16px', color: 'red'   }}> {item.comments} <br/></span> 
        </Typography>
          </div>
            <div style={{flexBasis: '80%', marginLeft:'2%',paddingLeft: '2%', borderLeft: '0.03em solid grey'}}>
            <Typography> 
           
           <span style={{ fontSize : '16px', color: '#333333'   }} > {item.speaker} ({item.affiliation}) <br/> </span>
           <span style={{  fontStyle: 'italic', fontSize : '16px', color: '#333333'   }}>   {item.title} <br/></span>    
        </Typography>
          </div>
      </ExpansionPanelSummary>
    
      <ExpansionPanelDetails style={{backgroundColor :'#E6EBE9'}}>
        <Typography style ={{marginLeft : '6%', width : '88%',  fontSize : '16px', color: '#333333'}}>
             Abstract:   
             <br/><br/> 
             {item.abstract} 
        </Typography>
      </ExpansionPanelDetails>
    </ExpansionPanel>

  );
    ;}
  
  
  export class Seminars extends Component {
    constructor(props){ 
      super(props);
      this.state={Spring2025:[], Spring2025Special:[], Spring2024:[], Fall2023:[], Spring2023:[],Fall2022:[],Spring2019:[],Fall2019:[],Spring2018:[],Fall2018:[],Spring2020:[],Fall2020:[],Summer2021:[],Fall2021:[],Spring2022:[]};

      
  }
    componentDidMount(){
      fetch('./JSON/Spring2025.json')
      .then(response => response.json())
      .then(data => {
        this.setState({Spring2025 :data.list})
      });
      fetch('./JSON/Spring2025Special.json')
      .then(response => response.json())
      .then(data => {
        this.setState({Spring2025Special :data.list})
      });
      fetch('./JSON/Spring2024.json')
      .then(response => response.json())
      .then(data => {
        this.setState({Spring2024 :data.list})
      });
      fetch('./JSON/Fall2023.json')
      .then(response => response.json())
      .then(data => {
        this.setState({Fall2023 :data.list})
      });
      fetch('./JSON/Spring2023.json')
      .then(response => response.json())
      .then(data => {
        this.setState({Spring2023 :data.list})
      });
      fetch('./JSON/Fall2022.json')
      .then(response => response.json())
      .then(data => {
        this.setState({Fall2022 :data.list})
      });
      fetch('./JSON/Spring2022.json')
      .then(response => response.json())
      .then(data => {
        this.setState({Spring2022 :data.list})
      });
      fetch('./JSON/Fall2021.json')
      .then(response => response.json())
      .then(data => {
        this.setState({Fall2021 :data.list})
      });
      fetch('./JSON/Summer2021.json')
      .then(response => response.json())
      .then(data => {
        this.setState({Summer2021 :data.list})
      });

      fetch('./JSON/Fall2020.json')
      .then(response => response.json())
      .then(data => {
        this.setState({Fall2020 :data.list})
      });

      fetch('./JSON/Spring2020.json')
      .then(response => response.json())
      .then(data => {
        this.setState({Spring2020 :data.list})
      });

      fetch('./JSON/Fall2019.json')
      .then(response => response.json())
      .then(data => {
        this.setState({Fall2019 :data.list})
      });
  
      fetch('./JSON/Spring2019.json')
      .then(response => response.json())
      .then(data => {
        this.setState({Spring2019 :data.list})
      });

      fetch('./JSON/Fall2018.json')
      .then(response => response.json())
      .then(data => {
        this.setState({Fall2018 :data.list})
      });

      fetch('./JSON/Spring2018.json')
      .then(response => response.json())
      .then(data => {
        this.setState({Spring2018 :data.list})
      });
    }  
    render(){
      
      return(   
     <div style={classes.paper}>

        <Typography align="center" 
                  style={{
                        marginTop:0, 
                        color:'#009688', 
                        align:'center',
                        paddingBottom:20,
                        borderBottom: 'solid 0.02em',
                        width:'60%',
                        marginBottom:0}} 
                  variant="h4" >
              Probability and Mathematical Physics Seminar
        </Typography>
        <Typography  align="center" style={classes.p}> 
          Tuesdays, 1.15pm-2.15pm in Room 3721<br/>
          Mathematics Department     
        </Typography>
        <Typography 
              style={{
                color:'#009688', 
                align:'center', 
                marginBottom:'3%', 
                marginTop:'3%'}} 
              variant="h5">
             Schedule Spring 2025
        </Typography>
        {this.state.Spring2025.map(item=> GenListItem(item))}
        <Typography 
              style={{
                color:'#009688', 
                align:'center', 
                marginBottom:'3%', 
                marginTop:'3%'}} 
              variant="h5">
              Spring 2025 Mini-Course 
        </Typography>
        {this.state.Spring2025Special.map(item=> GenListItem(item))}
        <Typography 
              style={{
                color:'#009688', 
                align:'center', 
                marginBottom:'3%', 
                marginTop:'3%'}} 
              variant="h5">
             Schedule Spring 2024 
        </Typography>
        {this.state.Spring2024.map(item=> GenListItem(item))}
        <Typography 
              style={{
                color:'#009688', 
                align:'center', 
                marginBottom:'3%', 
                marginTop:'3%'}} 
              variant="h5">
             Schedule Fall 2023 
        </Typography>
        {this.state.Fall2023.map(item=> GenListItem(item))}
        <Typography 
              style={{
                color:'#009688', 
                align:'center', 
                marginBottom:'3%', 
                marginTop:'3%'}} 
              variant="h5">
             Schedule Spring 2023 
        </Typography>
        {this.state.Spring2023.map(item=> GenListItem(item))} 
        <Typography align="center" 
                  style={{
                        marginTop:30, 
                        color:'#009688', 
                        align:'center',
                        paddingBottom:20,
                        borderBottom: 'solid 0.02em',
                        width:'60%',
                        marginBottom:0}} 
                  variant="h4" >
              Random matrix theory seminar <br></br>
              (continued as Probability and Mathematical Physics)
        </Typography>
         <Typography 
              style={{
                color:'#009688', 
                align:'center', 
                marginBottom:'3%', 
                marginTop:'3%'}} 
              variant="h5">
             Schedule Fall 2022 
        </Typography>
        {this.state.Fall2022.map(item=> GenListItem(item))} 
         <Typography 
              style={{
                color:'#009688', 
                align:'center', 
                marginBottom:'3%', 
                marginTop:'3%'}} 
              variant="h5">
             Schedule Spring 2022 
        </Typography>
        {this.state.Spring2022.map(item=> GenListItem(item))} 
       
       
         <Typography 
              style={{
                color:'#009688', 
                align:'center', 
                marginBottom:'3%', 
                marginTop:'3%'}} 
              variant="h5">
             Schedule Fall 2021  
        </Typography>
        {this.state.Fall2021.map(item=> GenListItem(item))} 
       
        
         <Typography 
              style={{
                color:'#009688', 
                align:'center', 
                marginBottom:'3%', 
                marginTop:'3%'}} 
              variant="h5">
             Schedule Summer 2021  
        </Typography>
        {this.state.Summer2021.map(item=> GenListItem(item))} 
       
        <Typography 
              style={{
                color:'#009688', 
                align:'center', 
                marginBottom:'3%', 
                marginTop:'3%'}} 
              variant="h5">
             Schedule Fall 2020  
        </Typography>
        {this.state.Fall2020.map(item=> GenListItem(item))} 

        <Typography 
              style={{
                color:'#009688', 
                align:'center', 
                marginBottom:'3%', 
                marginTop:'3%'}} 
              variant="h5">
             Schedule Spring 2020  <br>
             </br>
            
        </Typography>
       
         {this.state.Spring2020.map(item=> GenListItem(item))} 
         <Typography  style={{
                color:'#ff0000', 
                align:'center', 
                marginBottom:'3%', 
                marginTop:'3%',
                fontSize:'20px'}} 
             >
         Because of the ongoing COVID-19 pandemic all further seminars were canceled 
         </Typography>
        <Typography 
              style={{
                color:'#009688', 
                align:'center', 
                marginBottom:'3%', 
                marginTop:'3%'}} 
              variant="h5">
             Schedule Fall 2019   
        </Typography>
        {this.state.Fall2019.map(item=> GenListItem(item))}
      
        <Typography 
              style={{
                color:'#009688', 
                align:'center', 
                marginBottom:'3%',
                marginTop:'13%'}} 
              variant="h5">
          Schedule Spring 2019          
        </Typography>
         {this.state.Spring2019.map(item=> GenListItem(item))}

         <Typography 
              style={{
                color:'#009688', 
                align:'center', 
                marginBottom:'3%',
                marginTop:'13%'}} 
              variant="h5">
          Schedule Fall 2018          
        </Typography>
         {this.state.Fall2018.map(item=> GenListItem(item))}
         <Typography 
              style={{
                color:'#009688', 
                align:'center', 
                marginBottom:'3%',
                marginTop:'13%'}} 
              variant="h5">
          Schedule Spring 2018         
        </Typography>
         {this.state.Spring2018.map(item=> GenListItem(item))}

      </div>
     
     );
      }
  }
  
  export default Seminars;
